import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { updateData } from '../../../services';
import ConfirmDialog from '../../helpers/ConfirmDialog';

export const DeleteDesignForm = ({ design, setDesigns }) => {
    const { token, base_url } = useAppContext();

    return (
        <ConfirmDialog
            trigger={
                <button className="btn btn-action btn-danger" title="Delete Design">
                    <FontAwesomeIcon icon={faTrash} />
                    <span>Archive</span>
                </button>
            }
            title="Archive Design"
            message="Are you sure you want to archive this design?"
            entityLabel={`Design: ${design?.name}`}
            detail="This action will archive the design and remove it from your designs list. It will be added to the Archived Designs list and you can restore it at any time."
            confirmLabel="Archive Design"
            submittingLabel="Archiving..."
            successMessage="Design archived successfully!"
            errorMessages={{
                notFound: 'Design not found',
                client: 'Invalid design data. Please check your input.',
                default: 'Failed to archive design. Please try again.',
            }}
            onConfirm={async () => {
                const updated_design = await updateData(
                    token,
                    `${base_url}/apis/designs/${design.id}`,
                    { is_archived: true }
                );

                if (!updated_design.design) return false;

                setDesigns((prevDesigns) =>
                    prevDesigns.filter((d) => d.id !== design.id)
                );
            }}
        />
    );
};
